export default function () {
    const $numberContainer = $('.facts-number-digits');

    if (!$numberContainer.length) {
        return;
    }

    const $window = $(window);

    function animateNumbers(element) {
        const $this = $(element);
        const locale = 'de';
        const durationTime = Number($this.attr('data-duration'));
        const $number = Number($this.attr('data-number'));

        $this.prop('Counter', 0).animate({
            Counter: $this.text(),
        }, {
            duration: durationTime,
            easing: 'linear',
            step: (number) => {
                $this.text(Math.floor(number).toLocaleString(locale));
            },
            complete: () => {
                $this.text($number.toLocaleString(locale));
            },
        });
    }

    function checkIfElementIsInView() {
        // get current window information
        const windowTopPosition = $window.scrollTop();
        const windowBottomPosition = (windowTopPosition + $window.height());

        // iterate through elements to see which are in view
        $.each($numberContainer, (i, item) => {
            const $element = $(item);
            const elementHeight = $element.outerHeight();
            const elementTopPosition = $element.offset().top;
            const elementBottomPosition = (elementTopPosition + elementHeight);

            // check if element is in viewport
            if (
                elementBottomPosition >= windowTopPosition
                && elementTopPosition <= windowBottomPosition
                && !$element.hasClass('hasCounted')
            ) {
                animateNumbers(item);
                $element.addClass('hasCounted'); // every element counts up only once
            }
        });
    }

    // when we have any scrollable elements, check if they are in view
    // when the user loads/scrolls/resizes the window
    checkIfElementIsInView(); // on initial loading

    window.addEventListener('scroll', checkIfElementIsInView, { passive: true });
    window.addEventListener('resize', checkIfElementIsInView, { passive: true });
    window.addEventListener('orientationchange', checkIfElementIsInView, { passive: true });
}
